import { useQuery } from "react-query";
import axios from "../axios";

const useGetBalance = (sellerId) => {
  const query = useQuery(
    ["balance", sellerId], // ✅ unique per seller
    async () => {
      if (!sellerId) return null; // if sellerId not available yet
      return await axios.get(`/api/balance/${sellerId}`);
    },
    {
      enabled: !!sellerId, // ✅ only run if sellerId is defined
      staleTime: 30000, // cache time before refetch
    }
  );

  return query;
};

export default useGetBalance;
